import React from 'react';
import {injectIntl} from 'react-intl';

const DateValue = ({value, intl}) => (
    <>
        <span className="date-value">{intl.formatDate(value)}</span>
    </>
);

export default injectIntl(DateValue);
